import { SAVE_ALERT } from './actionTypes'
import { AlertsType } from './types'
import { AlertModel } from '../../../types/alert/alertModel'

export const saveAlerts = (contracts: AlertModel[]): AlertsType => {
	return ({
		type: SAVE_ALERT,
		payload: contracts
	})
}
